import { toast } from "react-toastify";
import { get, post, put } from "../../../services/api";
import {
  CONFIRMED_GET_COMPANIES,
  GET_COMPANIES_FAILED_ACTION,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAILED,
  UPDATE_COMPANY_FAILED,
  UPDATE_COMPANY_SUCCESS,
  CONFIRMED_GET_COMPANY,
  GET_COMPANIES_CONTACT_FAILED_ACTION,
  CONFIRMED_GET_COMPANIES_CONTACT,
  ADD_COMPANY_CONTACT_FAILED,
} from "./companyTypes";

export function companyFailedAction(data) {
  return {
    type: GET_COMPANIES_FAILED_ACTION,
    payload: data,
  };
}
export function companyContactFailedAction(data) {
  return {
    type: GET_COMPANIES_CONTACT_FAILED_ACTION,
    payload: data,
  };
}
export function addCompanyFailedAction(data) {
  return {
    type: ADD_COMPANY_FAILED,
    payload: data,
  };
}
export function addCompanyContactFailedAction(data) {
  return {
    type: ADD_COMPANY_CONTACT_FAILED,
    payload: data,
  };
}
export function addCompanySuccessAction(data) {
  return {
    type: ADD_COMPANY_SUCCESS,
    payload: data,
  };
}

export function getCompany(data) {
  return {
    type: CONFIRMED_GET_COMPANY,
    payload: data,
  };
}

export function getCompanyContact(data) {
  return {
    type: CONFIRMED_GET_COMPANIES_CONTACT,
    payload: data,
  };
}

export function updateCompanyFailedAction(data) {
  return {
    type: UPDATE_COMPANY_FAILED,
    payload: data,
  };
}
export function updateCompanySuccessAction(data) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    payload: data,
  };
}
export function getCompanyList(data) {
  return {
    type: CONFIRMED_GET_COMPANIES,
    payload: data,
  };
}

export function getCompanies(token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/company", token);
      dispatch(getCompanyList(res));
    } catch (e) {
      dispatch(
        companyFailedAction("Something went wrong while fetching companies..")
      );
    }
  };
}

export function addCompany(data, setModal, token, resetForm) {
  return async (dispatch) => {
    try {
      const res = await post("/api/company", data, token);
      if (res.status === 200) {
        toast.success("Company added successfully.");
        const res = await get("/api/company", token);
        dispatch(getCompanyList(res));
        if (resetForm) {
          resetForm();
        }
        setModal(false);
      } else {
        dispatch(
          addCompanyFailedAction(
            "Something went wrong while adding candidate. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        addCompanyFailedAction(
          "Something went wrong while adding candidate. Please try again"
        )
      );
    }
  };
}



export function updateCompany(data, setModal, id, token) {
  return async (dispatch) => {
    try {
      const res = await put(`/api/company/${id}`, data, token);
      if (res.status === 200) {
        toast.success(`${data?.companyName} has been updated successfully.`);
        const res = await get("/api/company", token);
        dispatch(getCompanyList(res));
        setModal(false);
      } else {
        dispatch(
          updateCompanyFailedAction(
            "Something went wrong while updated company. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        updateCompanyFailedAction(
          "Something went wrong while updated company. Please try again"
        )
      );
    }
  };
}

export function getCompanyById(id, token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/company/"+id, token);
      dispatch(getCompany(res));
    } catch (e) {
      dispatch(
        companyFailedAction(
          "Something went wrong while fetching candidates.."
        )
      );
    }
  };
}


export function getCompanyContactById(id, token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/company-contacts/company/"+id, token);
      dispatch(getCompanyContact(res));
    } catch (e) {
      dispatch(
        companyContactFailedAction(
          "Something went wrong while fetching candidates.."
        )
      );
    }
  };
}

export function addCompanyContact(data, setModal, token, resetForm) {
  return async (dispatch) => {
    try {
      const res = await post("/api/company-contacts", data, token);
      if (res.status === 200) {
        toast.success("Company contact has been added successfully.");
        const res = await get("/api/company-contacts/company/"+data?.companyId, token);
        dispatch(getCompanyContact(res));
        setModal(false);
        if (resetForm) {
          resetForm();
        }
      } else {
        dispatch(
          addCompanyContactFailedAction(
            "Something went wrong while adding candidate. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        addCompanyContactFailedAction(
          "Something went wrong while adding candidate. Please try again"
        )
      );
    }
  };
}


export function updateCompanyContact(data, id, token) {
  return async (dispatch) => {
    try {
      const res = await put("/api/company-contacts/"+id, data, token);
      if (res.status === 200) {
        toast.success("Company contact has been updated successfully.");
        const res = await get("/api/company-contacts/company/"+data?.companyId, token);
        dispatch(getCompanyContact(res));
      } else {
        toast.error("Something went wrong while company contact update.");
        dispatch(
          addCompanyContactFailedAction(
            "Something went wrong while adding candidate. Please try again"
          )
        );
      }
    } catch (e) {
      toast.error("Something went wrong while company contact update.");
      dispatch(
        addCompanyContactFailedAction(
          "Something went wrong while adding candidate. Please try again"
        )
      );
    }
  };
}